export default {
  improvementplans: {
    title: 'Kế hoạch cải thiện',
    high: 'Cao',
    middle: 'Trung bình',
    low: 'Thấp',
    exceed: 'Vượt quá',
    policy: 'Chính sách',
    measure: 'Hành động',
    result: 'Kết quả',
    currently_supporting: 'Đang trong tiến trình',
    completion: 'Đã hoàn tất',
    ended: 'Chưa hoàn tất',
    risk: 'Nguy cơ',
    thema: "@:{'common.esg.category'}",
    improvement_plan: 'Kế hoạch cải thiện',
    deadline_for_completion: 'Hạn cuối',
    message_count: 'Tin nhắn',
    operation: 'Vận hành',
    detail: "@:{'common.scorecard.detail'}",
    indicator: 'Chỉ số',
    indicator_point: 'Lời khuyên',
    buyer_indicator_point: 'Nhận xét đánh giá',
    status: 'Trạng thái',
    supported: 'Đã hoàn tất',
    unsupported: 'Không có hành động',
    progress: 'Trạng thái',
    advice: {
      text_line_1: '',
      text_line_2: '',
      text_line_3: 'Hãy bắt đầu cải thiện hiệu suất ESG của bạn từ đánh giá này.',
      text_line_4: 'Xem qua lời khuyên để đặt mục tiêu hoặc thời hạn từ "Tạo kế hoạch cải thiện".',
      text_line_5: 'Bạn có thể kiểm tra tiến trình trên biểu đồ bên trái.',
      text_line_6: 'Vui lòng ',
      contact: 'Liên hệ với chúng tôi ',
      please_contact_us: 'nếu muốn yêu cầu đánh giá lại.',
    },
    sub_section_title_1: 'Đang thực hiện kế hoạch cải thiện',
    no_data_display: 'Không có dữ liệu',
    sub_section_title_2: 'Lời khuyên chưa hoàn tất',
    buyer_sub_section_title_2: 'Nhận xét đánh giá chưa hoàn thành',
    operation_link_text: 'Tạo kế hoạch cải thiện',
    add_advice: 'Thêm lời khuyên',
    sub_section_title_3: 'Lời khuyên đã hoàn tất',
    buyer_sub_section_title_3: 'Nhận xét đánh giá đã hoàn thành',
    revaluation_request: 'Yêu cầu đánh giá lại',
    cautionary_note: 'Bạn có muốn yêu cầu đánh giá lại dựa trên kế hoạch cải thiện đã hoàn thành của mình không?',
    asterisked_text: 'Nếu muốn yêu cầu đánh giá lại, vui lòng gửi yêu cầu thông qua biểu mẫu liên hệ.',
    submit_btn_text: 'Yêu cầu đánh giá lại',
    table_state: 'tableState',
    select_a_file: 'Chọn một tệp',
    attached_file: 'Đính kèm tệp',
    notes: 'Ghi chú',
    created_improvement_plan: 'Đã tạo Kế hoạch cải thiện',
    error_file_upload: 'Đã xảy ra lỗi tải lên tệp',
    failed_to_create: 'Không tạo được kế hoạch cải thiện. Hãy thử làm mới trang.',
    no_data_found: 'Không tìm thấy dữ liệu để cải thiện',
    file_upload: {
      filesize_max: 'Vui lòng chọn các tệp nhỏ hơn 10 MB.',
      max_files: 'Bạn có thể tải tệp lên tối đa 10.',
      confirmation_of_deletion: 'Bạn có muốn xóa tệp này không?',
    },
    create_improvement_plan: 'Tạo kế hoạch cải thiện',
    no_data_improvement_plan: 'Hiện không có kế hoạch cải thiện nào.',
  },
  buyer_improvementplans: {
    flag: 'Cờ',
    memo: 'Bản ghi nhớ',
    flag_on: 'Đặt một cờ',
    flag_off: 'Xóa cờ',
    panel: {
      title: 'Thông tin công ty/Bản ghi nhớ của công ty',
      company_memo: 'Bản ghi nhớ của công ty',
      latest_memo: 'Bản ghi nhớ mới nhất',
      no_memo: 'Chưa có bản ghi nhớ nào.',
      check_list: 'Danh sách kiểm tra',
      memo_list: 'Danh sách bản ghi nhớ',
      // no_assignee: "",
      assignee_select_box: {
        // assignee: "",
        // placeholder: "",
        // create_member: "",
      },
      create_member_modal: {
        // title: "",
        // label: "",
        // place_holder: "",
      },
      delete_member_modal: {
        // title: "",
        // confirm_text: "",
        delete_button_label: "@:{'improvement_plans_detail.chat.delete_confirm.delete_button_label'}",
      },
    },
    back_to_list: 'Quay lại danh sách',
    action_cases: 'Trường hợp',
    no_improvements: 'Không có lĩnh vực nào được đề xuất cải tiến',
    confirm_delete_memo: 'Bạn có chắc chắn muốn xóa bản ghi nhớ này không?',
    confirm_delete_memo_title: 'Xóa một bản ghi nhớ',
    // display_only_is_marked: "",
    create_memo: 'Tạo một bản ghi nhớ',
  },
  improvement_plans_detail: {
    create_form: {
      cautions_title: '@:settings.cautions_title',
    },
  },
}
